import apiClient from "QueryClient/axiosClient";

export const getProfile = async () => {
  return apiClient.get(`/oneGradRep/getProfile`);
};
